/*
 * ---------------------------------------------------------------------
 * System Action Types
 * ---------------------------------------------------------------------
 */
export const SET_TOKEN = "SET_TOKEN";
export const SET_TOKEN_VALID = "SET_TOKEN_VALID";
